<template>
  <div class="consulta-unica ">
    <loading
      color="#2185d0"
      :active.sync="isLoading"
      loader="bars"
      :is-full-page="fullPage"
    ></loading>
    <div class="form ">
      <form>
        <div class="row">
          <div class="col-md-12">
            <base-input
              type="text"
              label="Cod. de rastreamento"
              placeholder="Cod. de rastreamento"
              v-model="processoSelecionado"
            ></base-input>
          </div>
        </div>

        <div class="text-center col-12">
          <button
            type="submit"
            class="btn btn-fill w-50 mb-4"
            @click.prevent="createHistoric"
          >
            Consultar
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
    <modal
      name="modal"
      :adaptive="true"
      :clickToClose="false"
      :width="this.capa.size"
      :class="'modalInfo'"
      :scrollable="true"
      height="auto"
      @before-close="clearCapa"
      :reset="true"
    >
      <div id="print" class="container capa-exibida">
        <div class="row">
          <loading
            color="#2185d0"
            :active.sync="this.isLoading"
            loader="bars"
            :is-full-page="fullPage"
          ></loading>
          <div class="col-12"></div>
          <div :class="capa.leftSize" v-if="processoSelecionado">
            
            <!-- COM FILTRO -->
            <template v-if="statusModal && !statusCompletos">
              <h3>TIMELINE</h3>
              <timeline>
                <timeline-title bg-color="#003d6b">{{processoSelecionado}}</timeline-title>
                <span v-for="(liStatus, index) in capa.listStatus" v-bind:key="liStatus.index">
                  <timeline-item v-if="liStatus != null && liStatus != false && liStatus != 0 " bg-color="#9dd8e0">
                    <p class="font-weight-bold">{{ index }}<span class="data">{{ isBoolean(liStatus) || "" }}</span></p>
                  </timeline-item>
                  <timeline-item v-if="liStatus === null || liStatus === false" :hollow="true">
                    <p> {{ index }} <span class="data">{{ isBoolean(liStatus) || "" }}</span></p>
                  </timeline-item>
                </span>
              </timeline>
            </template>

            <!-- SEM FILTROOOOO -->
            <template v-if="!statusModal || statusCompletos">
              <div class="col text-uppercase">
                <h3>Linha do Tempo</h3>
              </div>
              <timeline class="table border">
                <timeline-title bg-color="#003d6b">{{ processoSelecionado}}</timeline-title>
                <span v-for="(liStatus,index) in capa.listStatus" v-bind:key="liStatus.id">

                      <timeline-item
                        v-if="checkStatus(capa.last_status,liStatus.STATUS,liStatus)"
                        bg-color="#9dd8e0"
                      >
                        <p class="font-weight-bold">
                          {{liStatus.STATUS || index }} 
                          <span
                            class="data"
                          >{{isBoolean(liStatus) || "" }}</span>
                        </p>
                      </timeline-item>

                      <timeline-item v-else-if="index == 'Transbordo' " v-for="(transbordo) in liStatus" v-bind:key="transbordo.id">

                          <p > <span class="font-weight-bold ft-12">Transbordo - {{ transbordo.PORTO }} {{ transbordo.NAVIO }} - {{ transbordo.ETA | moment("DD/MM/YYYY") }} </span></p>
                
                      </timeline-item>

                      <timeline-item
                        v-else-if="index != 'Transbordo'"
                        :hollow="true"
                      >
                        <p>
                          {{liStatus.STATUS || index }}
                          <span
                            class="data"
                          >{{ isBoolean(liStatus) || ""}}</span>
                        </p>
                      </timeline-item>
                </span>
              </timeline>
            </template>
            <!-- TIMELINE -->
          </div>
          <!-- CAPA -->
          <div :class="capa.rightSize + ' d-print-block'">
            <capa :capa="capa" v-if="capa.status"></capa>
          </div>
          <div class="col-12">
            <div class="mr-auto ml-auto text-center">
              <button
                type="text"
                class="btn btn-info btn-fill btn-red ml-auto mr-auto mb-2 d-print-none"
                @click.prevent="hide"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { Timeline, TimelineItem, TimelineTitle } from "vue-cute-timeline";
import Capa from "src/components/Capa.vue";

export default {
  name: "consulta-unica",
  components: {
    Timeline,
    TimelineItem,
    TimelineTitle,
    Capa,
  },
  data() {
    return {
      processoSelecionado: "",
      statusModal: "",
      capa: {
        status: true,
        size: "80%",
        leftSize: "col-4",
        rightSize: "col-8",
        last_status: "",
        dadosGerais: {
          id: "",
          processo: "",
          reference: "",
          booking: "",
          tipo: "",
          shipper: "",
          cnee: "",
          deadline_date: "",
          deadline_hour: "",
          etd: "",
          eta: "",
          date_sent_eawb: "",
        },
        containers: {},
        tiposContainers: [],
        documentosAnexados: [],
      },
      statusCompletos: [],
      isLoading: false,
      fullPage: true,
      tipo: [],
    };
  },
  methods: {
    createHistoric() {
      this.isLoading = true;
      var url = this.$urlApi + "/api/processo-capa-rapida";
      let data = { processo: this.processoSelecionado };
      this.axios.post(url, data).then((res) => {
        if (res.data.status) {
          this.capa.listStatus = res.data.statusTimeLine;
          this.capa.dadosGeraisCapa = res.data.dadosGeraisCapa;
          this.statusCompletos = res.data.statusCompletos;
          this.isLoading = false;
          this.show();
        } else {
          alert(res.data.msg);
          this.isLoading = false;
          this.hide();
          //CME20000919 CHEGADA CONFIRMADA
        }
      });
    },
    clearCapa() {
      this.capa.listStatus = [];
      this.capa.status = true;
    },
    checkStatus(ultimo, atual, data) {
      console.log(ultimo + "-" + atual + "-" + data);
      let dataTrue;
      if (data.DATA_OK) {
        dataTrue = data.DATA_OK;
      } else if (typeof data === "string" && data) {
        dataTrue = data;
      }
      if (ultimo == atual || dataTrue != null || data === true) {
        return true;
      }
      return false;
    },
    show() {
      this.$modal.show("modal");
    },
    hide() {
      this.$modal.hide("modal");
    },
    isBoolean(valor) {
      if (typeof valor === "boolean") {
        return "";
      } else if (valor.DATA_OK) {
        return " - " + valor.DATA_OK;
      } else if (typeof valor === "string") {
        return " - " + valor;
      } else {
        return "";
      }
    },
  },
};
</script>
<style></style>
